
export function shortTagFromString(string) {
    let words = string?.split(' ');
    let firstChars = "-";
    if (words?.[0]?.[0] && words?.[1]?.[0]) {
        firstChars = words?.[0]?.[0] + words?.[1]?.[0];
    }

    return firstChars;
}